import React, { useState, useEffect } from "react";
import Card from "../../user/components/Card";
import CategorySelectDropdown from "../../user/components/CategorySelectDropdown";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../utils/Constants";
import {
  CreateProduct,
  DeleteProduct,
  ListProduct,
  StreamOptions,
  UpdateProduct,
  AnalyzeProductImage,
  BulkCreateProducts,
  TogglePublishProduct
} from "../services/prodcut.service";
import { GetCategoryList } from "../services/category.service";
import { GetSubCategoryList } from "../services/subcategory.service";
import { GetPreSubCategoryList, GetPreSubCategoryDetails } from "../services/presubcategory.service";
import * as XLSX from "xlsx";
import { useRef } from "react";
import { capitalizeFirstLetter, handleServerValidations, getUser } from "../../../utils/commonfunction";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Download, X, SlidersHorizontal } from "lucide-react";
import { profileDetails } from "../services/user.service";
import { SOCKET_EVENTS } from "../../../utils/Constants";
import { SOCKET_CLIENT } from "../../../utils/socket";
import { GetCommonAttributeList } from "../services/attribute.service";
import { getColorPalettes } from "../../user/services/stream.service";
import Select from "react-select";
import { useSelector } from "react-redux";
import { PALETTE_COLUMNS, METALLIC_COLORS, SPECIAL_COLORS, WHITE_SHADES, getColorTabName, getColorDotStyle } from "../../admin/common/colorPalettePicker";

const isVideoMedia = (item) => {
  if (!item) return false;
  if (typeof item === "string") {
    return /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item);
  }
  if (item.type === "video" || item.isVideo) return true;
  if (item.file && item.file.type && item.file.type.startsWith("video/")) return true;
  if (item.url && /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item.url)) return true;
  if (item.preview && /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item.preview)) return true;
  return false;
};

const METALLIC_COLORS_GRADIENT = [
  { name: "Metallic Gold", gradient: "linear-gradient(135deg, #bf953f 0%, #fcf6ba 25%, #b38728 50%, #fbf5b7 75%, #aa771c 100%)" },
  { name: "Metallic Silver", gradient: "linear-gradient(135deg, #9c9c9c 0%, #f1f1f1 50%, #c0c0c0 100%)" },
  { name: "Rose Gold", gradient: "linear-gradient(135deg, #b76e79 0%, #f3d1d6 50%, #9e505c 100%)" },
  { name: "Bronze", gradient: "linear-gradient(135deg, #8f5d38 0%, #dfbfa1 50%, #a87c53 100%)" },
  { name: "Copper", gradient: "linear-gradient(135deg, #8a4f1c 0%, #f0c2a2 50%, #b87333 100%)" },
  { name: "Champagne", gradient: "linear-gradient(135deg, #e3ceab 0%, #fff6e6 50%, #f7e7ce 100%)" }
];

const getColorPalateName = (name, hex) => {
  return getColorTabName(name, hex);
};

const getPaginationPages = (currentPage, totalPages) => {
  if (totalPages <= 4) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (currentPage <= 2) {
    return [1, 2, "...", totalPages];
  }
  if (currentPage >= totalPages - 1) {
    return [1, "...", totalPages - 1, totalPages];
  }
  return [1, "...", currentPage, "...", totalPages];
};

// Helper functions are now inside Products component

// Color helper functions are now inside Products component

function Products() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [imagePreview, setImagePreview] = useState(null);
  const [colorPalettes, setColorPalettes] = useState([]);
  const [colorKeys, setColorKeys] = useState(["COLOR REAL", "Color", "Colors"]);
  const [isColorPaletteBoxOpen, setIsColorPaletteBoxOpen] = useState(false);
  const [selectedPaletteIdForColors, setSelectedPaletteIdForColors] = useState(null);

  useEffect(() => {
    getColorPalettes().then(resp => {
      if (resp?.success && Array.isArray(resp.data)) {
        setColorPalettes(resp.data);
      }
    });

    GetCommonAttributeList({}).then(resp => {
      const dataArray = resp?.data || [];
      if (Array.isArray(dataArray)) {
        const keys = dataArray
          .filter(attr => attr.hasColorCode || attr.name.toLowerCase().includes("color") || attr.name.toLowerCase().includes("colour"))
          .map(attr => attr.name);
        if (keys.length > 0) {
          setColorKeys(keys);
        }
      }
    });
  }, []);


  const expandTabValues = (values) => {
    const expanded = [];
    (values || []).forEach(val => {
      if (val && typeof val === 'object' && val.colorCode && val.colorCode.startsWith("tab:")) {
        const tabName = val.colorCode.replace("tab:", "");
        const col = colorPalettes.find(c => c.name === tabName);
        if (col && col.colors) {
          col.colors.forEach(c => {
            expanded.push({
              name: c.name,
              colorCode: c.hex
            });
          });
        }
      } else {
        expanded.push(val);
      }
    });
    return expanded;
  };

  const getTabColors = (tabName) => {
    const col = colorPalettes.find(c => c.name === tabName);
    if (col && col.colors) {
      return col.colors.map(c => ({ name: c.name, colorCode: c.hex }));
    }
    return [];
  };

  const extractColorInfo = (val) => {
    if (!val) return { name: "", colorCode: "#ccc" };
    if (typeof val === 'string') {
      return { name: val, colorCode: "#ccc" };
    }
    let name = "";
    let colorCode = "#ccc";

    if (val.name) {
      if (typeof val.name === 'object' && val.name !== null) {
        name = val.name.name || "";
        colorCode = val.name.colorCode || val.colorCode || "#ccc";
      } else {
        name = String(val.name);
        colorCode = val.colorCode || "#ccc";
      }
    } else {
      name = String(val);
    }
    return { name, colorCode };
  };

  const getPalateBackground = (colors, palateName) => {
    if (!colors || colors.length === 0) return '#ccc';

    if (colors.length === 1) {
      const v = colors[0].name || "";
      const colorCode = colors[0].hex || colors[0].colorCode || "#ccc";
      const isTransparent = v.toLowerCase() === 'transparent' || colorCode === 'transparent';
      const isMulticolour = v.toLowerCase() === 'multicolour' || v.toLowerCase() === 'multicolor';
      const isMetallic = palateName.toLowerCase().includes('metallic');
      if (isTransparent) return 'repeating-conic-gradient(#ccc 0% 25%, white 0% 50%) 50% / 100% 100%';
      if (isMulticolour) return 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)';
      if (isMetallic) {
        const metallic = METALLIC_COLORS_GRADIENT.find(m => m.name.toLowerCase() === v.toLowerCase()) || { gradient: colorCode };
        return metallic.gradient;
      }
      return colorCode;
    }

    const segmentAngle = 360 / colors.length;
    const gradientParts = colors.map((item, idx) => {
      const start = idx * segmentAngle;
      const end = (idx + 1) * segmentAngle;
      let colorVal = item.hex || item.colorCode || '#ccc';
      const itemName = item.name || "";
      if (itemName.toLowerCase() === 'transparent' || colorVal === 'transparent') {
        colorVal = '#ffffff';
      } else if (itemName.toLowerCase() === 'multicolour' || itemName.toLowerCase() === 'multicolor') {
        colorVal = '#ff00ff';
      }
      return `${colorVal} ${start}deg ${end}deg`;
    });
    return `conic-gradient(${gradientParts.join(', ')})`;
  };

  const getSwatchColorCode = (colorName) => {
    if (!colorName) return "#ccc";
    const lowerName = colorName.toLowerCase().trim();

    // Check METALLIC_COLORS
    const metallic = METALLIC_COLORS.find(m => m.name.toLowerCase() === lowerName);
    if (metallic) return metallic.gradient || metallic.hex;

    // Check SPECIAL_COLORS
    const special = SPECIAL_COLORS.find(s => s.name.toLowerCase() === lowerName);
    if (special) {
      if (lowerName === 'transparent') return 'transparent';
      if (lowerName === 'multicolour' || lowerName === 'multicolor') return 'multicolour';
      return special.hex;
    }

    // Check WHITE_SHADES
    const white = WHITE_SHADES.find(w => w.name.toLowerCase() === lowerName);
    if (white) return white.hex;

    // Check colorPalettes
    for (const col of colorPalettes) {
      if (col.colors) {
        const found = col.colors.find(c => c.name.toLowerCase() === lowerName);
        if (found) return found.hex;
      }
    }

    return "#ccc";
  };
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(20);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [attributeSearch, setAttributeSearch] = useState("");
  const [attributeFacets, setAttributeFacets] = useState({}); // New state for dynamic attribute values
  const [expandedPalate, setExpandedPalate] = useState({});
  const [hoveredPalate, setHoveredPalate] = useState(null);

  const activeSelectedColors = [];
  colorKeys.forEach(key => {
    const searchKey = `attributes.${key}`;
    if (search && Array.isArray(search[searchKey])) {
      search[searchKey].forEach(c => {
        if (!activeSelectedColors.includes(c)) {
          activeSelectedColors.push(c);
        }
      });
    }
  });

  const toggleSubColor = (colorName) => {
    setSearch(prev => {
      const newState = { ...prev };
      let nextColors;
      if (activeSelectedColors.includes(colorName)) {
        nextColors = activeSelectedColors.filter(c => c !== colorName);
      } else {
        nextColors = [...activeSelectedColors, colorName];
      }

      colorKeys.forEach(key => {
        const searchKey = `attributes.${key}`;
        if (nextColors.length === 0) {
          delete newState[searchKey];
        } else {
          newState[searchKey] = nextColors;
        }
      });
      return newState;
    });
    setPage(1);
  };

  const toggleAllColorsInTab = (tabColors, selectAll) => {
    const tabColorNames = tabColors.map(c => c.name);
    setSearch(prev => {
      const newState = { ...prev };
      let nextColors;
      if (selectAll) {
        nextColors = [...new Set([...activeSelectedColors, ...tabColorNames])];
      } else {
        nextColors = activeSelectedColors.filter(c => !tabColorNames.includes(c));
      }

      colorKeys.forEach(key => {
        const searchKey = `attributes.${key}`;
        if (nextColors.length === 0) {
          delete newState[searchKey];
        } else {
          newState[searchKey] = nextColors;
        }
      });
      return newState;
    });
    setPage(1);
  };

  const clearColorFilter = () => {
    setSearch(prev => {
      const newState = { ...prev };
      colorKeys.forEach(key => {
        const searchKey = `attributes.${key}`;
        delete newState[searchKey];
      });
      return newState;
    });
    setSelectedPaletteIdForColors(null);
    setPage(1);
  };

  const [editMode, setEditMode] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const location = useLocation();
  const [streamData, setStreamData] = useState({});
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const fileInputRef = useRef(null);
  const [isImporting, setIsImporting] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);
  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);
  const [filterSubCategoryList, setFilterSubCategoryList] = useState([]);
  const [preSubCategoryList, setPreSubCategoryList] = useState([]);
  const [filterPreSubCategoryList, setFilterPreSubCategoryList] = useState([]);
  const [isSubCategoryLoading, setIsSubCategoryLoading] = useState(false);
  const [isPreSubCategoryLoading, setIsPreSubCategoryLoading] = useState(false);
  const [balanceData, setBalanceData] = useState(null);
  const [productDynamicAttributes, setProductDynamicAttributes] = useState([]);
  const [activeTabPopover, setActiveTabPopover] = useState(null);
  const [completePaletteActiveTab, setCompletePaletteActiveTab] = useState("common");
  const [openCatDropdown, setOpenCatDropdown] = useState(null); // 'category' | 'subcategory' | 'presubcategory' | null
  console.log("productDynamicAttributes", productDynamicAttributes);

  useEffect(() => {
    const colorDialog = document.getElementById("color-palette-modal");
    if (colorDialog) {
      const handleClose = () => {
        setActiveTabPopover(prev => prev && prev.tabName === "complete_palette" ? null : prev);
      };
      colorDialog.addEventListener("close", handleClose);

      if (activeTabPopover && activeTabPopover.tabName === "complete_palette") {
        if (!colorDialog.open) {
          colorDialog.showModal();
        }
      } else {
        if (colorDialog.open) {
          colorDialog.close();
        }
      }

      return () => {
        colorDialog.removeEventListener("close", handleClose);
      };
    }
  }, [activeTabPopover]);

  const [isAttributeLoading, setIsAttributeLoading] = useState(false);
  const [searchAttributes, setSearchAttributes] = useState([]);
  const userData = getUser() || {};

  const rawPermissions = location.state?.permissions || userData?.permissions || [];
  const permissions = typeof rawPermissions === 'string' ? (rawPermissions.startsWith('[') ? JSON.parse(rawPermissions) : [rawPermissions]) : (rawPermissions || []);
  const isAdvertiser = !userData?.seller_id && !location.state?.seller_id;
  const canCreate = isAdvertiser || permissions.includes("create_product");
  const canEdit = isAdvertiser || permissions.includes("edit_product");
  const canDelete = isAdvertiser || permissions.includes("delete_product");

  const validationSchema = Yup.object({
    title: Yup.string()
      .trim()
      .required(t("vaildation.name"))
      .min(3, t("vaildation.title_min_length"))
      .max(35, t("vaildation.title_max_length"))
      .matches(/[a-zA-Z0-9]/, t("vaildation.only_number")),
    picture: Yup.mixed().when("$editMode", {
      is: false,
      then: (schema) =>
        schema
          .required(t("vaildation.picture"))
          .test("fileType", t("vaildation.image_format"), (value) => {
            if (!value) return false;
            return [
              "image/jpeg",
              "image/png",
              "image/jpg",
              "image/gif",
              "video/mp4",
              "video/webm",
              "video/quicktime",
              "video/x-matroska",
              "video/avi",
              "video/m4v",
              "video/ogg",
            ].includes(value.type) || value.type?.startsWith("image/") || value.type?.startsWith("video/");
          }),
      otherwise: (schema) => schema.nullable(),
    }),
    description: Yup.string()
      .trim()
      .required(t("vaildation.description"))
      .min(10, t("vaildation.desc_min_length"))
      .matches(/[a-zA-Z0-9]/, t("vaildation.only_number")),
    price: Yup.number().when('isAskForPrice', {
      is: true,
      then: (schema) => schema.nullable().notRequired(),
      otherwise: (schema) => schema
        .required(t("vaildation.price"))
        .typeError(t("vaildation.only_number"))
        .positive(t("vaildation.price_min"))
        .min(1, t("vaildation.price_min"))
        .max(99999, t("vaildation.price_max"))
        .test("maxDigits", t("vaildation.price_max"), (val) => !val || String(Math.floor(val)).length <= 7),
    }),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      picture: null,
      description: "",
      price: "",
      stream_id: "",
      categoryId: "",
      subcategoryId: "",
      preSubCategoryId: "",
      useAI: true,
      attributes: [{ name: "", value: "" }],
      isPublished: false,
      isAskForPrice: false,
      colors: [],
      product_images: [],
    },


    validationSchema: validationSchema,
    context: { editMode },
    onSubmit: async (values, { setSubmitting }) => {
      let formData = new FormData();
      formData.append("title", values.title);

      if (values.product_images && values.product_images.length > 0) {
        const images_metadata = [];
        const firstFileIndex = values.product_images.findIndex(item => item.file);

        values.product_images.forEach((item, index) => {
          const isVid = isVideoMedia(item);
          const type = isVid ? "video" : "image";
          if (item.file) {
            const key = index === firstFileIndex ? "image" : `file_${index}`;
            formData.append(key, item.file);
            images_metadata.push({ key, color: item.color || null, type });
          } else if (item.url) {
            images_metadata.push({ url: item.url, color: item.color || null, type });
          }
        });
        formData.append("images_metadata", JSON.stringify(images_metadata));
      } else if (values.picture) {
        formData.append("image", values.picture);
      }

      formData.append("description", values.description);
      formData.append("price", values.price);
      formData.append("stream_id", values.stream_id);
      if (values.categoryId) {
        formData.append("categoryId", values.categoryId);
      }
      if (values.subcategoryId) {
        formData.append("subcategoryId", values.subcategoryId);
      }
      if (values.preSubCategoryId) {
        formData.append("preSubCategoryId", values.preSubCategoryId);
      }
      formData.append("isPublished", values.isPublished);
      formData.append("isAskForPrice", values.isAskForPrice);


      const attributesObj = {};
      let finalColors = [];
      if (values.product_images && values.product_images.length > 1) {
        finalColors = Array.from(new Set(values.product_images.map(img => img.color).filter(Boolean)));
      } else {
        finalColors = values.colors || [];
      }

      if (finalColors.length > 0) {
        attributesObj["Colors"] = finalColors;
      }
      values.attributes.forEach(attr => {
        if (attr.name && attr.value) {
          attributesObj[attr.name] = attr.value;
        }
      });
      if (Object.keys(attributesObj).length > 0) {
        formData.append("attributes", JSON.stringify(attributesObj));
      }



      try {
        if (editMode) {
          formData.append("_id", editProductId);
          const response = await UpdateProduct(formData);

          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });

            handleCloseModal();
            setStatusUpdate(!statsupdate);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        } else {
          const response = await CreateProduct(formData);

          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });

            handleCloseModal();
            setStatusUpdate(!statsupdate);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setSubmitting(false); // ✅ important
      }
    },
  });

  const handleImportClick = () => {
    fileInputRef.current?.click();
  };

  const handleImportFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        setIsImporting(true);
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        if (data.length === 0) {
          Swal.fire("Error", "The Excel file is empty", "error");
          return;
        }

        // Basic validation: Check for Title and Price columns
        const firstRow = data[0];
        if (!firstRow.hasOwnProperty("Title") || !firstRow.hasOwnProperty("Price")) {
          Swal.fire("Error", "Invalid file format. Please use the sample template (Title and Price are required).", "error");
          return;
        }

        // Map data to backend format
        const products = data.map(item => ({
          title: item.Title,
          description: item.Description || "",
          price: item.Price,
          category: item.Category || "",
          image_url: item.ImageURL || ""
        }));

        const resp = await BulkCreateProducts(products);
        if (resp.success) {
          const { inserted_count, skipped, invalid } = resp.data;
          let message = `${inserted_count} products imported successfully.`;
          if (skipped.length > 0) message += `\n${skipped.length} duplicates skipped.`;
          if (invalid.length > 0) message += `\n${invalid.length} invalid rows found.`;

          Swal.fire("Success", message, "success");
          fetchData(); // Refresh list
        } else {
          Swal.fire("Error", resp.message || "Failed to import products", "error");
        }
      } catch (err) {
        console.error("Import error:", err);
        Swal.fire("Error", "Failed to process Excel file", "error");
      } finally {
        setIsImporting(false);
        e.target.value = null; // Clear input
      }
    };
    reader.readAsBinaryString(file);
  };

  const downloadSample = () => {
    const sampleData = [
      { Title: "Sample Product 1", Description: "High quality sample product", Price: 19.99, Category: "Electronics", ImageURL: "https://example.com/image1.jpg" },
      { Title: "Sample Product 2", Description: "Another sample item", Price: 25.50, Category: "Home & Garden", ImageURL: "" },
    ];
    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products Template");
    XLSX.writeFile(wb, "products_sample_template.xlsx");
  };

  const fetchData = async () => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", page);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      const resp = await ListProduct(formData);
      if (resp.success) {
        setList(resp.data.list);
        setDataLength(resp.data.total_records);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.currentTarget.files || []);
    if (selectedFiles.length > 0) {
      const MAX_VIDEO_SIZE = 5 * 1024 * 1024;
      const oversizedVideo = selectedFiles.find(file => {
        const isVid = file.type.startsWith("video/") || /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(file.name);
        return isVid && file.size > MAX_VIDEO_SIZE;
      });

      if (oversizedVideo) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: t("Video size should not be more than 5 MB") || "Video size should not be more than 5 MB",
          ...SWAL_SETTINGS
        });
        event.target.value = "";
        return;
      }

      // Count existing videos already added
      const existingVideos = (formik.values.product_images || []).filter(img => isVideoMedia(img));
      const newVideos = selectedFiles.filter(file => file.type.startsWith("video/") || /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(file.name));
      if (existingVideos.length + newVideos.length > 1) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Only 1 video is allowed per product.",
          ...SWAL_SETTINGS
        });
        event.target.value = "";
        return;
      }

      const newImages = selectedFiles.map(file => ({
        file,
        preview: URL.createObjectURL(file),
        color: "",
        type: file.type.startsWith("video/") ? "video" : "image"
      }));
      const updatedImages = [...(formik.values.product_images || []), ...newImages];
      formik.setFieldValue("product_images", updatedImages);

      const firstImage = updatedImages[0];
      if (firstImage && firstImage.file) {
        formik.setFieldValue("picture", firstImage.file);
      }

      const fileToAnalyze = selectedFiles[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        // AI analysis if enabled
        if (reader.result && formik.values.useAI) {
          const clicks = (balanceData?.remaining_ai_clicks ?? userData?.remaining_ai_clicks ?? 0);
          if (clicks <= 0) {
            Swal.fire({
              icon: "warning",
              title: "Insufficient AI Clicks",
              text: "You have 0 AI clicks remaining. Please purchase an AI package or disable AI extraction to proceed.",
              ...SWAL_SETTINGS
            });
            formik.setFieldValue("useAI", false);
            return;
          }

          setIsAnalyzing(true);
          try {
            const resp = await AnalyzeProductImage(reader.result);
            if (resp.success && resp.data) {
              // Auto-fill fields if they are empty
              if (!formik.values.title) formik.setFieldValue("title", resp.data.title || "");
              if (!formik.values.description) formik.setFieldValue("description", resp.data.description || "");

              // Refresh balance after successful analysis
              if (resp.data.remaining_ai_clicks !== undefined) {
                setBalanceData(prev => ({ ...prev, remaining_ai_clicks: resp.data.remaining_ai_clicks }));
              } else {
                fetchBalance();
              }
            } else {
              if (resp.data && resp.data.remaining_ai_clicks !== undefined) {
                setBalanceData(prev => ({ ...prev, remaining_ai_clicks: resp.data.remaining_ai_clicks }));
              }
              Swal.fire({
                icon: "error",
                title: "Analysis Failed",
                text: resp.message || "Failed to analyze image",
                ...SWAL_SETTINGS
              });
            }
          } catch (err) {
            console.error("AI analysis failed:", err);
            if (err.response?.data?.data?.remaining_ai_clicks !== undefined) {
              setBalanceData(prev => ({ ...prev, remaining_ai_clicks: err.response.data.data.remaining_ai_clicks }));
            }
          } finally {
            setIsAnalyzing(false);
          }
        }
      };
      reader.readAsDataURL(fileToAnalyze);
    }
  };

  const fetchBalance = async () => {
    try {
      const res = await profileDetails();
      const userProfile = res?.data || res;
      if (userProfile) {
        setBalanceData(userProfile);
      }
    } catch (err) {
      console.error("Error fetching balance:", err);
    }
  };

  useEffect(() => {
    fetchBalance();

    // Listen for balance updates
    const sellerId = userData?._id;
    if (sellerId) {
      SOCKET_CLIENT.on(SOCKET_EVENTS.AI_CLICKS_UPDATED, (newBalance) => {
        if (newBalance.seller_id === sellerId) {
          setBalanceData(prev => ({
            ...prev,
            ...newBalance
          }));
        }
      });
    }

    return () => {
      SOCKET_CLIENT.off(SOCKET_EVENTS.AI_CLICKS_UPDATED);
    };
  }, []);

  const handleOpenCreateModal = () => {
    setEditMode(false);
    setEditProductId(null);
    formik.resetForm({
      values: {
        title: "",
        picture: null,
        description: "",
        price: "",
        stream_id: "",
        categoryId: "",
        subcategoryId: "",
        preSubCategoryId: "",
        useAI: true,
        attributes: [{ name: "", value: "" }],
        isPublished: false,
        isAskForPrice: false,
        colors: [],
      },
    });

    setProductDynamicAttributes([]);

    setImagePreview(null);
    // Clear the native file input (React can't reset file inputs via state)
    const fileInput = document.getElementById("picture");
    if (fileInput) fileInput.value = "";
    document.getElementById("create-product").showModal();
  };

  const handleOpenEditModal = (product) => {
    setEditMode(true);
    setEditProductId(product._id);

    const productColors = [];
    if (product.attributes) {
      colorKeys.forEach(key => {
        if (product.attributes[key]) {
          const val = product.attributes[key];
          const arr = Array.isArray(val) ? val : [val];
          arr.forEach(v => {
            const name = (v && typeof v === 'object' && v.name) ? (typeof v.name === 'object' ? v.name.name : v.name) : v;
            if (name && !productColors.includes(name)) {
              productColors.push(name);
            }
          });
        }
      });
    }

    const existingImages = product.images && product.images.length > 0
      ? product.images.map(img => ({
        url: img.url,
        preview: img.url,
        color: img.color || "",
        type: img.type || (isVideoMedia(img.url) ? "video" : "image")
      }))
      : (product.image ? [{ url: product.image, preview: product.image, color: "", type: isVideoMedia(product.image) ? "video" : "image" }] : []);

    formik.setValues({
      title: product.title || "",
      picture: null,
      description: product.description || "",
      price: product.price || "",
      stream_id: product.stream_id || "",
      categoryId: product.categoryId || "",
      subcategoryId: product.subcategoryId || "",
      preSubCategoryId: product.preSubCategoryId || "",
      isPublished: product.isPublished || false,
      isAskForPrice: product.isAskForPrice || false,
      colors: productColors,
      product_images: existingImages,
      attributes: product.attributes ? Object.entries(product.attributes).filter(([name]) => !colorKeys.includes(name)).map(([name, value]) => {
        const sanitizeValue = (val) => {
          if (val && typeof val === 'object') {
            if (val.name && typeof val.name === 'object' && val.name.name) {
              return val.name.name;
            }
            if (val.name && typeof val.name === 'string') {
              return val.name;
            }
          }
          return val;
        };

        let valStr = value;
        if (Array.isArray(value)) {
          valStr = value.map(sanitizeValue);
        } else {
          valStr = sanitizeValue(value);
        }
        return { name, value: valStr };
      }) : [{ name: "", value: "" }],
    });

    if (product.preSubCategoryId) {
      GetPreSubCategoryDetails(product.preSubCategoryId).then(res => {
        const responseData = res.data || res;
        const attributes = responseData.data?.attributes || responseData.attributes;
        if (attributes && Array.isArray(attributes)) {
          setProductDynamicAttributes(attributes);
        }
      });
    }



    // Set image preview to frames[0] if available, otherwise use product.image
    const previewImage = product.image;

    setImagePreview(previewImage);
    document.getElementById("create-product").showModal();
  };

  const handleCloseModal = () => {
    formik.resetForm();
    setImagePreview(null);
    setEditMode(false);
    setEditProductId(null);
    document.getElementById("create-product").close();
  };

  function DeleteFunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FF63B5",
      cancelButtonColor: "#FF63B5",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        let ids = Array.isArray(data) ? data : [data];
        DeleteProduct(ids)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const TogglePublish = async (item) => {
    try {
      const response = await TogglePublishProduct({
        _id: item._id,
        isPublished: !item.isPublished
      });
      if (response.success) {
        Swal.fire({
          icon: "success",
          text: response.message,
          ...SWAL_SETTINGS,
        });
        setStatusUpdate(!statsupdate);
      } else {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(response),
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", page);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        ListProduct(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            if (data?.data?.attribute_facets) {
              setAttributeFacets(data.data.attribute_facets);
            }
            setLoader(false);
          })

          .catch((error) => {
            console.log("error ====> ", error);
            setLoader(false);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, page]);

  // Handle subcategory fetching for filter dropdown
  useEffect(() => {
    if (search.categoryId) {
      GetSubCategoryList({ categoryId: search.categoryId })
        .then((data) => {
          if (data?.list) {
            setFilterSubCategoryList(data?.list);
          } else {
            setFilterSubCategoryList([]);
          }
        })
        .catch((error) => {
          console.error("Filter SubCategory Fetch error ====> ", error);
          setFilterSubCategoryList([]);
        });
    } else {
      setFilterSubCategoryList([]);
      if (search.subcategoryId) {
        prepareSearch("subcategoryId", "");
      }
    }
  }, [search.categoryId]);

  // Handle pre-subcategory fetching for filter dropdown
  useEffect(() => {
    if (search.subcategoryId) {
      GetPreSubCategoryList({ subcategoryId: search.subcategoryId })
        .then((data) => {
          if (data?.list) {
            setFilterPreSubCategoryList(data?.list);
          } else {
            setFilterPreSubCategoryList([]);
          }
        })
        .catch((error) => {
          console.error("Filter Pre-SubCategory Fetch error ====> ", error);
          setFilterPreSubCategoryList([]);
        });
    } else {
      setFilterPreSubCategoryList([]);
      if (search.preSubCategoryId) {
        prepareSearch("preSubCategoryId", "");
      }
    }
  }, [search.subcategoryId]);

  // Fetch attributes for filter
  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        if (search.preSubCategoryId) {
          const res = await GetPreSubCategoryDetails(search.preSubCategoryId);
          const responseData = res.data || res;
          const attributes = responseData.data?.attributes || responseData.attributes;
          if (attributes && Array.isArray(attributes) && attributes.length > 0) {
            setSearchAttributes(attributes);
            return;
          }
        }

        if (search.categoryId) {
          const data = await GetCommonAttributeList({ categoryId: search.categoryId });
          if (data?.data) {
            setSearchAttributes(data.data);
          } else {
            setSearchAttributes([]);
          }
        } else {
          setSearchAttributes([]);
        }
      } catch (error) {
        console.error("Filter Attribute Fetch error:", error);
        setSearchAttributes([]);
      }
    };

    fetchAttributes();
  }, [search.categoryId, search.preSubCategoryId]);


  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (value && String(value).length > 0) {
      sr[key] = value;
    } else if (key.startsWith("attributes.")) {
      // Allow empty values for attributes so the filter row remains visible for selection
      sr[key] = "";
    } else {
      delete sr[key];
    }

    // If category changes, clear subcategory and attributes
    if (key === "categoryId") {
      delete sr["subcategoryId"];
      // Clear all attribute filters
      Object.keys(sr).forEach(k => {
        if (k.startsWith("attributes.")) delete sr[k];
      });
    }

    if (key === "subcategoryId") {
      delete sr["preSubCategoryId"];
    }
    setSearch(sr);

    setPage(1);
  };

  useEffect(() => {
    StreamOptions()
      .then((data) => {
        setStreamData(data?.data);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });

    GetCategoryList({ filter_by_user: true })
      .then((data) => {
        if (data?.list) {
          setCategoryList(data?.list);
        }
      })
      .catch((error) => {
        console.log("Category Fetch error ====> ", error);
      });
  }, []);

  useEffect(() => {
    if (formik.values.categoryId) {
      setIsSubCategoryLoading(true);
      GetSubCategoryList({ categoryId: formik.values.categoryId })
        .then((data) => {
          if (data?.list) {
            setSubCategoryList(data?.list);
          } else {
            setSubCategoryList([]);
          }
        })
        .catch((error) => {
          console.error("SubCategory Fetch error ====> ", error);
          setSubCategoryList([]);
        })
        .finally(() => {
          setIsSubCategoryLoading(false);
        });
    } else {
      setSubCategoryList([]);
      formik.setFieldValue("subcategoryId", "");
      setPreSubCategoryList([]);
      formik.setFieldValue("preSubCategoryId", "");
    }
  }, [formik.values.categoryId]);

  useEffect(() => {
    if (formik.values.subcategoryId) {
      setIsPreSubCategoryLoading(true);
      GetPreSubCategoryList({ subcategoryId: formik.values.subcategoryId })
        .then((data) => {
          if (data?.list) {
            setPreSubCategoryList(data?.list);
          } else {
            setPreSubCategoryList([]);
          }
        })
        .catch((error) => {
          console.error("PreSubCategory Fetch error ====> ", error);
          setPreSubCategoryList([]);
        })
        .finally(() => {
          setIsPreSubCategoryLoading(false);
        });
    } else {
      setPreSubCategoryList([]);
      formik.setFieldValue("preSubCategoryId", "");
    }
  }, [formik.values.subcategoryId]);

  // No background useEffect for attributes to avoid race conditions


  const totalPages = Math.ceil((datalength || 0) / itemperpage);

  return (
    <>
      <div className="stream-details-bg py-8 md:py-10">
        <div className="container">
          <div className="flex items-center justify-between flex-wrap gap-[10px] border-b border-gray-200 pb-[15px] mb-[30px]">
            <h1 className="headings-h1 text-zinc-950">
              {t("products.heading")}
            </h1>
            <div className="flex items-center gap-3 flex-wrap">
              <button
                className="btn flex items-center justify-center btn-pri !bg-zinc-800 !border-zinc-800 text-sm p"
                onClick={downloadSample}
              >
                <div className="flex items-center gap-2"><Download className="w-4 h-4 " />
                  <span>{t('advertiser.products.sample_excel')}</span>   </div>

              </button>
              {canCreate && (
                <>
                  <button
                    className="btn btn-pri !bg-green-600 !border-green-600 text-sm flex items-center gap-2"
                    onClick={handleImportClick}
                    disabled={isImporting}
                  >
                    {isImporting ? t('advertiser.products.importing') : t('advertiser.products.import_csv')}
                  </button>
                  <button
                    className="btn btn-pri !bg-[#FF63B5] !border-[#FF63B5]"
                    onClick={handleOpenCreateModal}
                  >
                    {t('advertiser.products.add_button')}
                  </button>
                </>
              )}
              <input
                type="file"
                ref={fileInputRef}
                className="hidden"
                accept=".xlsx, .xls"
                onChange={handleImportFileChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-12 items-center lg:gap-4 gap-3 mb-[30px]">
            <div className="lg:col-span-4 sm:col-span-8 col-span-12">
              <div className="search-box relative flex-1">
                <input
                  type="search"
                  className="form-control-custom !pr-[50px]"
                  value={globalsearch}
                  placeholder={t("advertiser.products.search_placeholder")}
                  onChange={(e) => {
                    setPage(1)
                    setGlobalSearch(e.target.value);
                  }}
                />
                <button className="absolute right-2 top-3 right-3">
                  <img src="/images/search1.svg" className="size-5" alt="search" />
                </button>
              </div>
            </div>
            <div className="lg:col-span-2 sm:col-span-4 col-span-6">
              <div className="flex-1">
                <CategorySelectDropdown
                  value={search.categoryId || ""}
                  onChange={(val) => prepareSearch("categoryId", val)}
                  options={categoryList}
                  placeholder={t("parent_category")}
                  fallbackIcon="/category.png"
                  capitalize={true}
                  buttonClassName="!py-2 !rounded-lg"
                />
              </div>
            </div>
            <div className="lg:col-span-2 sm:col-span-4 col-span-6">
              <div className="flex-1">
                <CategorySelectDropdown
                  value={search.subcategoryId || ""}
                  onChange={(val) => prepareSearch("subcategoryId", val)}
                  options={filterSubCategoryList}
                  placeholder={t("sub_categories")}
                  disabled={!search.categoryId}
                  fallbackIcon="/category.png"
                  capitalize={true}
                  buttonClassName="!py-2 !rounded-lg"
                />
              </div>
            </div>
            <div className="lg:col-span-2 sm:col-span-4 col-span-6">
              <div className="flex-1">
                <CategorySelectDropdown
                  value={search.preSubCategoryId || ""}
                  onChange={(val) => prepareSearch("preSubCategoryId", val)}
                  options={filterPreSubCategoryList}
                  placeholder={t("pre_sub_categories")}
                  disabled={!search.subcategoryId}
                  fallbackIcon="/category.png"
                  capitalize={true}
                  buttonClassName="!py-2 !rounded-lg"
                />
              </div>
            </div>
            <div className="lg:col-span-2 sm:col-span-4 col-span-6">
              {/* Color Palette Popover Dropdown */}
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setIsColorPaletteBoxOpen(!isColorPaletteBoxOpen)}
                  className="appearance-none pl-4 pr-10 py-2.5 w-full rounded-xl border border-gray-200 bg-white shadow-sm text-sm font-semibold text-gray-700 cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FF63B5] text-left flex items-center justify-between hover:border-[#FF63B5] hover:shadow-md transition-all"
                >
                  <span className="truncate">
                    {activeSelectedColors.length > 0
                      ? `Filter by Color (${activeSelectedColors.length})`
                      : "Filter by Color"}
                  </span>
                  <div className="absolute right-4 inset-y-0 flex items-center pointer-events-none text-gray-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                </button>

                {isColorPaletteBoxOpen && (
                  <>
                    <div className="fixed inset-0 z-30" onClick={() => setIsColorPaletteBoxOpen(false)} />
                    <div
                      className="absolute left-auto right-0 -translate-x-0 top-full mt-2.5 z-40 w-[350px] bg-white rounded-2xl shadow-[0_10px_35px_rgba(0,0,0,0.15)] border border-gray-100 p-4 animate-zoomIn origin-top"
                    >
                      {selectedPaletteIdForColors ? (
                        // Sub-colors selection view
                        (() => {
                          const selectedPalette = colorPalettes.find(p => p._id === selectedPaletteIdForColors);
                          if (!selectedPalette) return null;
                          const palateName = selectedPalette.name;
                          const tabColors = selectedPalette.colors || [];

                          return (
                            <div className="flex flex-col">
                              <div className="flex items-center justify-between border-b border-gray-100 pb-2 mb-3">
                                <button
                                  type="button"
                                  onClick={() => setSelectedPaletteIdForColors(null)}
                                  className="flex items-center gap-1 text-xs font-bold text-[#FF63B5] hover:underline"
                                >
                                  ← Back
                                </button>
                                <span className="text-xs font-extrabold text-gray-800 uppercase tracking-wide">
                                  {palateName} Colors
                                </span>
                                <div className="flex gap-2">
                                  <button
                                    type="button"
                                    onClick={() => toggleAllColorsInTab(tabColors, true)}
                                    className="text-[10px] font-bold text-[#FF63B5] hover:underline"
                                  >
                                    All
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => toggleAllColorsInTab(tabColors, false)}
                                    className="text-[10px] font-bold text-gray-400 hover:underline"
                                  >
                                    None
                                  </button>
                                </div>
                              </div>

                              <div className="max-h-60 overflow-y-auto space-y-1.5 custom-scrollbar pr-0.5">
                                {tabColors.map(color => {
                                  const isSelected = activeSelectedColors.includes(color.name);
                                  let swatchBg = color.hex;
                                  if (color.name === "Transparent") {
                                    swatchBg = 'repeating-linear-gradient(45deg, #e0e0e0, #e0e0e0 4px, #ffffff 4px, #ffffff 8px)';
                                  } else if (color.name === "Multicolour") {
                                    swatchBg = 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)';
                                  } else if (color.gradient) {
                                    swatchBg = color.gradient;
                                  }

                                  return (
                                    <button
                                      key={color.name}
                                      type="button"
                                      onClick={() => toggleSubColor(color.name)}
                                      className={`w-full flex items-center justify-between p-1.5 rounded-lg border text-left transition-all ${isSelected
                                        ? "border-[#FF8E8E] bg-[#FFEDED]/30 font-semibold"
                                        : "border-transparent hover:bg-gray-50"
                                        }`}
                                    >
                                      <div className="flex items-center gap-2">
                                        <div
                                          style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            background: swatchBg,
                                            border: "1px solid rgba(0,0,0,0.15)"
                                          }}
                                        />
                                        <span className="text-[11px] text-gray-700">{color.name}</span>
                                      </div>
                                      <input
                                        type="checkbox"
                                        checked={isSelected}
                                        readOnly
                                        className="w-3.5 h-3.5 accent-[#FF63B5] cursor-pointer"
                                      />
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })()
                      ) : (
                        // Palettes grid view
                        <div className="flex flex-col">
                          <div className="flex items-center justify-between border-b border-gray-100 pb-2 mb-3">
                            <span className="text-[11px] font-extrabold text-gray-500 uppercase tracking-wider">
                              Color Palettes
                            </span>
                            {activeSelectedColors.length > 0 && (
                              <button
                                type="button"
                                onClick={clearColorFilter}
                                className="text-[10px] font-bold text-red-500 hover:text-red-600 bg-red-50 px-2 py-0.5 rounded transition-all"
                              >
                                Reset
                              </button>
                            )}
                          </div>

                          <div className="grid grid-cols-3 gap-y-4 gap-x-2 max-h-80 overflow-y-auto custom-scrollbar p-1">
                            {colorPalettes.map(palette => {
                              const palateName = palette.name;
                              const tabColors = palette.colors || [];
                              const tabColorNames = tabColors.map(c => c.name);
                              const selectedInTab = activeSelectedColors.filter(c => tabColorNames.includes(c));
                              const isAnySelected = selectedInTab.length > 0;
                              const bgStyle = getPalateBackground(tabColors, palateName);

                              return (
                                <button
                                  key={palette._id}
                                  type="button"
                                  onClick={() => {
                                    setSelectedPaletteIdForColors(palette._id);
                                    toggleAllColorsInTab(tabColors, true);
                                  }}
                                  className="flex flex-col items-center group/palette focus:outline-none"
                                >
                                  <div
                                    className="relative rounded-full transition-all duration-200"
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      background: bgStyle,
                                      border: isAnySelected
                                        ? "3.5px solid #FF63B5"
                                        : "2px solid #e2e8f0",
                                      boxShadow: isAnySelected
                                        ? "0 0 10px rgba(255, 99, 181, 0.7)"
                                        : "none",
                                      transform: "scale(1)"
                                    }}
                                  >
                                    {selectedInTab.length > 0 && (
                                      <div className="absolute -top-1.5 -right-1.5 bg-[#FF63B5] text-white text-[9px] font-bold w-4.5 h-4.5 rounded-full flex items-center justify-center border border-white">
                                        {selectedInTab.length}
                                      </div>
                                    )}
                                  </div>
                                  <span className="text-[10px] text-gray-600 font-bold mt-1 text-center leading-snug w-full truncate group-hover/palette:text-[#FF63B5]">
                                    {palateName}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Filter Content & Results Header */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <h2 className="text-xl font-bold text-gray-800">
                {t("advertiser.products.results")}
              </h2>
              <span className="bg-gray-100 text-gray-600 px-3 py-0.5 rounded-full text-sm font-medium">
                {datalength || 0}
              </span>
            </div>

            {search.preSubCategoryId && (
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setIsFilterOpen(!isFilterOpen)}
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all shadow-sm active:scale-95 ${isFilterOpen || Object.keys(search).some(k => k.startsWith("attributes."))
                    ? "bg-[#FF63B5] text-white shadow-[var(--secondary-200)]"
                    : "bg-white text-gray-700 border border-gray-200 hover:border-[var(--secondary-300)]"
                    }`}
                >
                  <SlidersHorizontal className="w-4 h-4" />
                  {t('advertiser.products.filter')}
                  {Object.keys(search).filter(k => k.startsWith("attributes.") && search[k]).length > 0 && (
                    <span className="ml-1 bg-white text-[#FF63B5] w-5 h-5 rounded-full flex items-center justify-center text-[10px]">
                      {Object.keys(search).filter(k => k.startsWith("attributes.") && search[k]).length}
                    </span>
                  )}
                </button>

                {/* Dropdown Filter Box */}
                {isFilterOpen && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setIsFilterOpen(false)} />

                    <div className="absolute right-0 top-full mt-2 z-20 w-[440px] bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] border border-gray-100 flex flex-col overflow-hidden animate-zoomIn origin-top-right">
                      {/* Header */}
                      <div className="flex items-center justify-between px-5 py-1.5">
                        <h3 className="text-[13px] font-extrabold text-[#111]">{t('advertiser.products.attributes')}</h3>
                        <button
                          type="button"
                          onClick={() => {
                            let newSr = { ...search };
                            Object.keys(newSr).forEach(k => {
                              if (k.startsWith("attributes.")) delete newSr[k];
                            });
                            setSearch(newSr);
                            setPage(1);
                            setIsFilterOpen(false);
                          }}
                          className="text-[#FF8E8E] text-[10px] font-bold hover:opacity-80 transition-opacity"
                        >
                          {t('advertiser.products.reset_all')}
                        </button>
                      </div>

                      {/* Attributes Section Header */}
                      <div className="px-5 pb-1">
                        <div className="flex items-center gap-2 mb-1">
                          {/* <span className="text-[11px] font-extrabold text-[#111]">{t('advertiser.products.attributes')}</span> */}
                        </div>
                        <div className="h-[1px] bg-gray-50 w-full mb-2" />
                        <input
                          type="text"
                          placeholder="Search attributes..."
                          value={attributeSearch}
                          onChange={(e) => setAttributeSearch(e.target.value)}
                          className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-[#FF63B5]"
                        />
                      </div>

                      {/* Body */}
                      <div className="max-h-[300px] overflow-y-auto px-5 py-2 pb-5 space-y-4 custom-scrollbar bg-white">
                        {searchAttributes.length > 0 ? (
                          <div className="space-y-4">
                            {searchAttributes.map((attr) => {
                              const attrName = attr.name;
                              const facetValues = attributeFacets[attrName] || [];
                              const colorMap = {};

                              const attrValuesNames = (attr.values || []).map(val => {
                                if (val && typeof val === 'object') {
                                  if (val.name && typeof val.name === 'object' && val.name.name) {
                                    const colorName = val.name.name;
                                    const colorCode = val.name.colorCode || null;
                                    if (colorName) {
                                      colorMap[colorName] = colorCode;
                                      return colorName;
                                    }
                                  }
                                  if (val.name && typeof val.name === 'string') {
                                    const colorName = val.name;
                                    const colorCode = val.colorCode || null;
                                    colorMap[colorName] = colorCode;
                                    return colorName;
                                  }
                                }
                                return String(val || '');
                              }).filter(v => v.trim() !== '');

                              const sanitizedFacetValues = facetValues.map(val => {
                                if (val && typeof val === 'object') {
                                  if (val.name && typeof val.name === 'object' && val.name.name) {
                                    const colorName = val.name.name;
                                    const colorCode = val.name.colorCode || null;
                                    if (colorName) {
                                      colorMap[colorName] = colorCode;
                                      return colorName;
                                    }
                                  }
                                  if (val.name && typeof val.name === 'string') {
                                    const colorName = val.name;
                                    const colorCode = val.colorCode || null;
                                    colorMap[colorName] = colorCode;
                                    return colorName;
                                  }
                                }
                                return String(val || '');
                              }).filter(v => v.trim() !== '');

                              const allValues = [...new Set([...attrValuesNames, ...sanitizedFacetValues])];

                              const isColor = attrName.toLowerCase().includes('color') || attrName.toLowerCase().includes('colour') || attrName.toLowerCase().includes('palate') || attrName.toLowerCase().includes('palette') || attr.hasColorCode;

                              if (isColor) return null;

                              // Filter based on search
                              if (attributeSearch && !attrName.toLowerCase().includes(attributeSearch.toLowerCase())) return null;

                              if (attr.attributeType === 'user_input' && !attr.isVisibleInFilter && !isColor) return null;

                              const filteredValues = allValues
                                .map(v => {
                                  if (v === null || v === undefined) return '';
                                  if (typeof v === 'object') return v.name || '';
                                  return String(v);
                                })
                                .filter(v => v.trim() !== '');

                              if (filteredValues.length === 0) return null;

                              const searchKey = `attributes.${attrName}`;
                              const currentSelected = search[searchKey];

                              return (
                                <div key={attr._id} className="space-y-1.5">
                                  <label className="text-[11px] font-extrabold text-[#111]">
                                    {capitalizeFirstLetter(attrName)}
                                  </label>
                                  {isColor ? (
                                    <div className="space-y-2.5 w-full">
                                      {(() => {
                                        const groups = {};
                                        filteredValues.forEach(v => {
                                          const colorCode = colorMap[v] || (v.toLowerCase() === 'nude' ? '#E3BC9A' : v.toLowerCase() === 'transparent' ? 'transparent' : v.toLowerCase().replace(/ /g, ''));
                                          const palateName = getColorPalateName(v, colorCode);
                                          if (!groups[palateName]) groups[palateName] = [];
                                          groups[palateName].push({ name: v, colorCode });
                                        });

                                        return (
                                          <div className="space-y-3">
                                            {/* Grid of Palette Circles */}
                                            <div className="grid grid-cols-6 gap-2.5">
                                              {colorPalettes.map(col => col.name).map(palateName => {
                                                const tabColors = getTabColors(palateName);
                                                const tabColorNames = tabColors.map(c => c.name);

                                                const currentSelectedArray = Array.isArray(currentSelected)
                                                  ? currentSelected
                                                  : (currentSelected ? [currentSelected] : []);

                                                const selectedInTab = currentSelectedArray.filter(v => tabColorNames.includes(v));
                                                const selectedCount = selectedInTab.length;
                                                const isAllSelected = tabColorNames.length > 0 && tabColorNames.every(c => currentSelectedArray.includes(c));

                                                const bgStyle = getPalateBackground(tabColors, palateName);

                                                return (
                                                  <div key={palateName} className="relative flex flex-col items-center">
                                                    <button
                                                      type="button"
                                                      onClick={() => {
                                                        let newSr = { ...search };
                                                        let next;
                                                        if (isAllSelected) {
                                                          next = currentSelectedArray.filter(val => !tabColorNames.includes(val));
                                                        } else {
                                                          next = [...new Set([...currentSelectedArray, ...tabColorNames])];
                                                        }

                                                        if (next.length === 0) {
                                                          delete newSr[searchKey];
                                                        } else {
                                                          newSr[searchKey] = next;
                                                        }
                                                        setSearch(newSr);
                                                        setPage(1);
                                                      }}
                                                      onMouseEnter={() => setHoveredPalate(palateName)}
                                                      onMouseLeave={() => setHoveredPalate(null)}
                                                      style={{
                                                        width: "38px",
                                                        height: "38px",
                                                        borderRadius: "50%",
                                                        background: bgStyle,
                                                        border: selectedCount > 0
                                                          ? "3px solid #FF63B5"
                                                          : "1.5px solid #e2e8f0",
                                                        cursor: "pointer",
                                                        transform: hoveredPalate === palateName ? "scale(1.15)" : "none",
                                                        transition: "all 0.2s ease",
                                                        boxShadow: selectedCount > 0
                                                          ? "0 0 8px rgba(255, 99, 181, 0.6)"
                                                          : "none"
                                                      }}
                                                      title={`${palateName} Palette`}
                                                    />

                                                    <span className="text-[8px] text-gray-500 font-bold mt-1 text-center max-w-[50px] overflow-hidden text-ellipsis whitespace-nowrap">
                                                      {palateName}
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        );
                                      })()}
                                    </div>
                                  ) : (
                                    <div className="flex flex-wrap gap-1.5">
                                      {filteredValues.map((v, i) => {
                                        const isSelected = Array.isArray(currentSelected)
                                          ? currentSelected.includes(v)
                                          : currentSelected === v;

                                        return (
                                          <button
                                            key={i}
                                            type="button"
                                            onClick={() => {
                                              let newSr = { ...search };
                                              if (isSelected) {
                                                if (Array.isArray(currentSelected)) {
                                                  const next = currentSelected.filter(val => val !== v);
                                                  if (next.length === 0) delete newSr[searchKey];
                                                  else newSr[searchKey] = next;
                                                } else {
                                                  delete newSr[searchKey];
                                                }
                                              } else {
                                                if (Array.isArray(currentSelected)) {
                                                  newSr[searchKey] = [...currentSelected, v];
                                                } else if (currentSelected) {
                                                  newSr[searchKey] = [currentSelected, v];
                                                } else {
                                                  newSr[searchKey] = [v];
                                                }
                                              }
                                              setSearch(newSr);
                                              setPage(1);
                                            }}
                                            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] font-bold transition-all ${isSelected
                                              ? "bg-[#FFEDED] border-[#FF8E8E] text-[#FF8E8E]"
                                              : "bg-white border-[#F2F2F2] text-[#111] hover:border-gray-300"
                                              }`}
                                          >
                                            {v}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="text-center py-6">
                            <p className="text-gray-400 text-xs font-medium italic">{t('advertiser.products.no_additional_filters')}</p>
                          </div>
                        )}
                      </div>

                      {/* Footer */}
                      <div className="px-5 pb-5 pt-1">
                        <button
                          type="button"
                          onClick={() => {
                            setIsFilterOpen(false);
                            setPage(1);
                          }}
                          className="w-full bg-[#FF63B5] text-white py-3 rounded-xl text-[13px] font-extrabold shadow-md hover:brightness-110 active:scale-[0.98] transition-all"
                        >
                          {t('advertiser.products.apply_filters')}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

          </div>


          <div className="associated-products-bg py-8 pb-0">
            {loader ? (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-gray-600 text-lg">{t('advertiser.products.loading')}</p>
                </div>
              </div>
            ) : list && list.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-3 sm:gap-4">
                {list.map((item, index) => (
                  <div className="cursor-pointer" >
                    <Card
                      onClick={() => navigate(`/advertiser/product-details?o_id=${item?._id}`)}
                      key={index}
                      images={item.image}
                      title={capitalizeFirstLetter(item.title)}
                      price={item.price}
                      isAskForPrice={item.isAskForPrice}
                      subtitle={item.description ? capitalizeFirstLetter(item.description) : ""}
                      editDelete={canEdit || canDelete}
                      isPublished={item.isPublished}
                      onPublish={canEdit ? (e) => {
                        e.stopPropagation();
                        TogglePublish(item);
                      } : undefined}
                      onEdit={canEdit ? (e) => {
                        e.stopPropagation();
                        handleOpenEditModal(item);
                      } : undefined}
                      onDelete={canDelete ? (e) => {
                        e.stopPropagation();
                        DeleteFunction(item._id);
                      } : undefined}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center min-h-[400px]">
                <p className="text-gray-500 text-lg">{t('advertiser.products.no_products')}</p>
              </div>
            )}
          </div>
        </div>
        {list && list.length > 0 && totalPages > 1 && (
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 mt-8 flex-wrap">

            {/* Previous Button */}
            <button
              className="px-3.5 py-1.5 border border-gray-200 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition shadow-2xs"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              {t('advertiser.products.prev')}
            </button>

            {/* Page Numbers */}
            {getPaginationPages(page, totalPages).map((p, idx) =>
              p === "..." ? (
                <span
                  key={`ellipsis-${idx}`}
                  className="px-2 text-sm font-bold text-gray-400 select-none"
                >
                  …
                </span>
              ) : (
                <button
                  key={`page-${p}`}
                  onClick={() => setPage(p)}
                  className={`min-w-[36px] h-9 px-3 py-1 text-sm font-semibold rounded-xl border transition shadow-2xs ${page === p
                    ? "bg-[#FF63B5] text-white border-[#FF63B5] shadow-xs"
                    : "bg-white text-gray-700 hover:bg-gray-50 border-gray-200"
                    }`}
                >
                  {p}
                </button>
              )
            )}

            {/* Next Button */}
            <button
              className="px-3.5 py-1.5 border border-gray-200 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition shadow-2xs"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              {t('advertiser.products.next')}
            </button>

          </div>
        )}

      </div >

      {/* Modal */}
      < dialog id="create-product" className="modal p-[15px]" >
        <div className="modal-box max-w-[645px] !w-full">
          <h2 className="headings-h1 text-left text-zinc-800 mb-4">
            {editMode ? t("Edit Product") : t("products.create_product")}
          </h2>          <form onSubmit={formik.handleSubmit}>
            {/* Picture Upload - Moved to Top */}
            <div className="form-group">
              <div className="flex items-center justify-between mb-2">
                <label className="!mb-0">{t("products.picture")}</label>
                <div className="flex items-center gap-2">
                  {String(globalData?.show_ai_data_extraction) !== "false" && (
                    <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${(balanceData?.remaining_ai_clicks ?? userData?.remaining_ai_clicks ?? 0) > 0 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                      {(balanceData?.remaining_ai_clicks ?? userData?.remaining_ai_clicks ?? 0)} {t('advertiser.products.clicks_remaining')}
                    </span>
                  )}
                </div>
              </div>

              <div className="relative">
                <input
                  id="picture"
                  name="picture"
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  className={`form-control-custom ${formik.touched.picture && formik.errors.picture ? "border-red-500" : ""}`}
                  onChange={handleFileChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("picture").click()}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                >
                  <img src="/images/upload.svg" alt="Upload" />
                </button>
              </div>

              {formik.touched.picture && formik.errors.picture && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.picture}
                </p>
              )}

              {/* AI Extraction Toggle */}
              {String(globalData?.show_ai_data_extraction) !== "false" && (
                <div className="mt-4 mb-4 p-3 bg-indigo-50 rounded-lg border border-indigo-100 flex items-center justify-between">
                  <div>
                    <p className="text-sm font-bold text-indigo-900">{t('advertiser.products.ai_extraction')}</p>
                    <p className="text-[10px] text-indigo-700">{t('advertiser.products.ai_extraction_desc')}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className={`text-[10px] font-bold ${!formik.values.useAI ? "text-gray-900" : "text-gray-400"}`}>OFF</span>
                    <input
                      type="checkbox"
                      className="toggle border-indigo-600 bg-gray-200 checked:border-indigo-600 checked:bg-indigo-600"
                      checked={formik.values.useAI}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const clicks = (balanceData?.remaining_ai_clicks ?? userData?.remaining_ai_clicks ?? 0);
                        if (isChecked && clicks <= 0) {
                          Swal.fire({
                            icon: "warning",
                            title: t('advertiser.products.insufficient_clicks'),
                            text: t('advertiser.products.insufficient_clicks_desc'),
                            ...SWAL_SETTINGS
                          });
                          return;
                        }
                        formik.setFieldValue("useAI", isChecked);
                      }}
                    />
                    <span className={`text-[10px] font-bold ${formik.values.useAI ? "text-indigo-600" : "text-gray-400"}`}>ON</span>
                  </div>
                </div>
              )}

              {formik.values.product_images && formik.values.product_images.length > 0 && (
                <div className="mt-3 grid grid-cols-3 gap-4">
                  {formik.values.product_images.map((img, index) => {
                    const isVid = isVideoMedia(img);
                    return (
                      <div key={index} className="relative group border border-zinc-150 p-2 rounded-xl bg-zinc-50 flex flex-col gap-2">
                        <div className="aspect-square w-full rounded-lg overflow-hidden relative bg-black/5 flex items-center justify-center">
                          {isVid ? (
                            <video
                              src={img.preview || img.url}
                              className="w-full h-full object-cover"
                              muted
                              loop
                              playsInline
                            />
                          ) : (
                            <img
                              src={img.preview || img.url}
                              alt={`Upload ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          )}
                          {isVid && (
                            <div className="absolute top-1 left-1 bg-black/70 text-white text-[9px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1 backdrop-blur-sm z-10">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 text-red-500">
                                <path fillRule="evenodd" d="M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.39-2.901A1 1 0 007 8v4a1 1 0 001.39.911l4-2a1 1 0 000-1.822l-4-2z" clipRule="evenodd" />
                              </svg>
                              VIDEO
                            </div>
                          )}
                          <button
                            type="button"
                            title={t("Remove")}
                            onClick={() => {
                              const updated = formik.values.product_images.filter((_, idx) => idx !== index);
                              formik.setFieldValue("product_images", updated);
                              if (updated.length > 0) {
                                formik.setFieldValue("picture", updated[0].file || null);
                              } else {
                                formik.setFieldValue("picture", null);
                              }
                            }}
                            className="absolute top-1.5 right-1.5 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 shadow-md z-20 cursor-pointer transition-transform hover:scale-110 flex items-center justify-center"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>

                        {formik.values.product_images.length > 1 && (
                          <div className="flex flex-col">
                            <label className="text-[9px] font-bold text-zinc-400 uppercase tracking-wider">{t("Color Mapping")}</label>
                            <button
                              type="button"
                              onClick={() => {
                                setActiveTabPopover({
                                  attrId: "image_color",
                                  imageIndex: index,
                                  tabName: "complete_palette"
                                });
                              }}
                              className={`mt-1 flex items-center justify-center gap-1.5 w-full py-1.5 px-2 rounded-lg border text-xs font-bold transition-all ${img.color
                                ? "border-[var(--secondary-500)] bg-[var(--secondary-50)] text-[var(--secondary-700)]"
                                : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                                }`}
                              style={{
                                borderColor: img.color ? "#FF63B5" : "#e2e8f0"
                              }}
                            >
                              {img.color && (
                                <span
                                  className="w-2.5 h-2.5 rounded-full border border-gray-300 inline-block flex-shrink-0"
                                  style={{ backgroundColor: getSwatchColorCode(img.color) }}
                                />
                              )}
                              <span className="truncate">{img.color || t("Select Color")}</span>
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {isAnalyzing && (
                <div className="mt-2 flex items-center gap-2 text-sm text-indigo-600 font-medium">
                  <div className="w-4 h-4 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                  {t('advertiser.products.ai_extracting')}
                </div>
              )}
            </div>

            <div className="form-group">
              <label>{t("products.title")}</label>
              <input
                type="text"
                name="title"
                className={`form-control-custom ${formik.touched.title && formik.errors.title ? "border-red-500" : ""}`}
                placeholder={t("products.placeholder.title")}
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.title && formik.errors.title && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.title}
                </p>
              )}
            </div>

            <div className="form-group">
              <label>{t("products.description")}</label>
              <textarea
                name="description"
                className={`form-control-custom !h-[120px] ${formik.touched.description && formik.errors.description ? "border-red-500" : ""}`}
                placeholder={t("products.placeholder.description")}
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.description && formik.errors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.description}
                </p>
              )}
            </div>

            {(!formik.values.product_images || formik.values.product_images.length <= 1) && (
              <div className="form-group">
                <label className="text-sm font-medium text-zinc-600 mb-1 d-block">
                  Colors <span className="text-[10px] ml-2 text-zinc-400">(Multi-select)</span>
                </label>
                <div className="mt-2 space-y-3 w-full">
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => {
                        setActiveTabPopover(
                          activeTabPopover && activeTabPopover.attrId === "default_colors" && activeTabPopover.tabName === "complete_palette"
                            ? null
                            : { attrId: "default_colors", tabName: "complete_palette" }
                        );
                      }}
                      className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-bold transition-all ${formik.values.colors && formik.values.colors.length > 0
                        ? "border-[var(--secondary-500)] bg-[var(--secondary-50)] text-[var(--secondary-700)]"
                        : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                        }`}
                      style={{
                        boxShadow: formik.values.colors && formik.values.colors.length > 0 ? "0 0 8px rgba(255, 99, 181, 0.2)" : "none",
                        borderColor: formik.values.colors && formik.values.colors.length > 0 ? "#FF63B5" : "#e2e8f0"
                      }}
                    >
                      <span
                        className="w-4 h-4 rounded-full border border-gray-300 inline-block flex-shrink-0"
                        style={{
                          background: formik.values.colors && formik.values.colors.length > 0
                            ? getPalateBackground(formik.values.colors.map(c => ({ name: c, colorCode: getSwatchColorCode(c) })), "Custom")
                            : "linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)"
                        }}
                      />
                      <span>Select Colors</span>
                      {formik.values.colors && formik.values.colors.length > 0 && (
                        <span className="bg-[#FF63B5] text-white text-[9px] px-1.5 py-0.5 rounded-full">
                          {formik.values.colors.length}
                        </span>
                      )}
                    </button>
                  </div>

                  {/* Selected Colors Badges */}
                  {formik.values.colors && formik.values.colors.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mt-2">
                      {formik.values.colors.map(v => (
                        <span key={v} className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-2 py-0.5 rounded-lg text-[10px] font-semibold">
                          {v}
                          <button
                            type="button"
                            onClick={() => {
                              formik.setFieldValue("colors", formik.values.colors.filter(x => x !== v));
                            }}
                            className="text-gray-400 hover:text-gray-600 font-bold"
                          >
                            ✕
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="form-group mb-2">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="isAskForPrice"
                  className="w-4 h-4 accent-[#FF63B5]"
                  checked={formik.values.isAskForPrice}
                  onChange={formik.handleChange}
                />
                <span className="text-sm font-medium">Ask for price</span>
              </label>
            </div>

            {!formik.values.isAskForPrice && (
              <div className="form-group">
                <label>{t("products.price")}</label>
                <input
                  type="number"
                  name="price"
                  min="1"
                  max="9999999"
                  step="0.01"
                  className={`form-control-custom ${formik.touched.price && formik.errors.price ? "border-red-500" : ""}`}
                  placeholder={t("products.placeholder.price")}
                  value={formik.values.price}
                  onChange={(e) => {
                    // Strip to max 7 integer digits before decimal
                    const raw = e.target.value;
                    const parts = raw.split(".");
                    if (parts[0].replace("-", "").length > 7) return;
                    formik.setFieldValue("price", raw);
                  }}
                  onBlur={formik.handleBlur}
                  onKeyDown={(e) => {
                    // Block e, E, +, - keys
                    if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                  }}
                />
                {formik.touched.price && formik.errors.price && (
                  <p className="text-red-500 text-sm mt-1">
                    {formik.errors.price}
                  </p>
                )}
              </div>
            )}
            <div className="form-group">
              <label>{t("products.stream")}</label>
              <select
                name="stream_id"
                className={`form-control-custom ${formik.touched.stream_id && formik.errors.stream_id ? "border-red-500" : ""}`}
                value={formik.values.stream_id || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">
                  {t("products.placeholder.select_stream")}
                </option>
                {streamData && streamData.length > 0
                  ? streamData.map((stream) => (
                    <option key={stream._id} value={stream._id}>
                      {capitalizeFirstLetter(stream.title)}
                    </option>
                  ))
                  : null}
              </select>
              {formik.touched.stream_id && formik.errors.stream_id && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.stream_id}
                </p>
              )}
            </div>

            <div className="form-group">
              <label>{t("products.category")}<span className="text-red-500 ml-1">*</span></label>
              <div className="relative" ref={(el) => { if (el) el._catDropRef = true; }}>
                <button
                  type="button"
                  className={`form-control-custom w-full flex items-center gap-2 text-left ${formik.touched.categoryId && formik.errors.categoryId ? "border-red-500" : ""}`}
                  onClick={() => setOpenCatDropdown(v => v === 'category' ? null : 'category')}
                  onBlur={() => { setTimeout(() => setOpenCatDropdown(v => v === 'category' ? null : v), 150); formik.setFieldTouched('categoryId', true); }}
                >
                  {formik.values.categoryId ? (() => { const c = categoryList.find(x => x._id === formik.values.categoryId); return c ? (<><img src={c.image || c.icon || '/category.png'} alt="" className="w-6 h-6 rounded object-cover flex-shrink-0" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} /><span className="truncate">{capitalizeFirstLetter(c.title)}</span></>) : <span className="text-gray-400">{t("products.placeholder.select_category")}</span>; })() : <span className="text-gray-400">{t("products.placeholder.select_category")}</span>}
                  <span className="ml-auto text-gray-400">▾</span>
                </button>
                {openCatDropdown === 'category' && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-56 overflow-y-auto">
                    <div className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-gray-400 text-sm" onClick={() => { formik.setFieldValue('categoryId', ''); setOpenCatDropdown(null); }}>
                      <img src="/category.png" alt="" className="w-6 h-6 rounded object-cover flex-shrink-0 border border-gray-100" />
                      {t("products.placeholder.select_category")}
                    </div>
                    {categoryList.map(cat => (
                      <div key={cat._id} className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-pink-50 transition-colors ${formik.values.categoryId === cat._id ? 'bg-pink-50 font-semibold' : ''}`}
                        onClick={() => { formik.setFieldValue('categoryId', cat._id); setOpenCatDropdown(null); }}>
                        <img src={cat.image || cat.icon || '/category.png'} alt={cat.title} className="w-7 h-7 rounded object-cover flex-shrink-0 border border-gray-100" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} />
                        <span className="text-sm text-gray-700">{capitalizeFirstLetter(cat.title)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {formik.touched.categoryId && formik.errors.categoryId && (
                <p className="text-red-500 text-sm mt-1">{formik.errors.categoryId}</p>
              )}
            </div>

            <div className="form-group mb-4">
              <label>{t("sub_categories")}<span className="text-red-500 ml-1">*</span></label>
              <div className="relative">
                <button
                  type="button"
                  disabled={!formik.values.categoryId || isSubCategoryLoading}
                  className={`form-control-custom w-full flex items-center gap-2 text-left disabled:opacity-50 disabled:cursor-not-allowed ${formik.touched.subcategoryId && formik.errors.subcategoryId ? "border-red-500" : ""}`}
                  onClick={() => setOpenCatDropdown(v => v === 'subcategory' ? null : 'subcategory')}
                  onBlur={() => { setTimeout(() => setOpenCatDropdown(v => v === 'subcategory' ? null : v), 150); formik.setFieldTouched('subcategoryId', true); }}
                >
                  {isSubCategoryLoading
                    ? <span className="text-gray-400">{t('advertiser.notifications.loading')}</span>
                    : formik.values.subcategoryId
                      ? (() => { const s = subCategoryList.find(x => x._id === formik.values.subcategoryId); return s ? (<><img src={s.image || s.icon || '/category.png'} alt="" className="w-6 h-6 rounded object-cover flex-shrink-0" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} /><span className="truncate">{s.title}</span></>) : <span className="text-gray-400">{t('advertiser.products.select_sub_category')}</span>; })()
                      : <span className="text-gray-400">{t('advertiser.products.select_sub_category')}</span>
                  }
                  <span className="ml-auto text-gray-400">▾</span>
                </button>
                {openCatDropdown === 'subcategory' && !isSubCategoryLoading && formik.values.categoryId && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-56 overflow-y-auto">
                    <div className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-gray-400 text-sm" onClick={() => { formik.setFieldValue('subcategoryId', ''); setOpenCatDropdown(null); }}>
                      <img src="/category.png" alt="" className="w-6 h-6 rounded object-cover flex-shrink-0 border border-gray-100" />
                      {t('advertiser.products.select_sub_category')}
                    </div>
                    {subCategoryList.map(sub => (
                      <div key={sub._id} className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-pink-50 transition-colors ${formik.values.subcategoryId === sub._id ? 'bg-pink-50 font-semibold' : ''}`}
                        onClick={() => { formik.setFieldValue('subcategoryId', sub._id); setOpenCatDropdown(null); }}>
                        <img src={sub.image || sub.icon || '/category.png'} alt={sub.title} className="w-7 h-7 rounded object-cover flex-shrink-0 border border-gray-100" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} />
                        <span className="text-sm text-gray-700">{sub.title}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {formik.touched.subcategoryId && formik.errors.subcategoryId && (
                <p className="text-red-500 text-sm mt-1">{formik.errors.subcategoryId}</p>
              )}
            </div>

            <div className="form-group mb-4">
              <label>{t("pre_sub_categories")}<span className="text-red-500 ml-1">*</span></label>
              <div className="relative">
                <button
                  type="button"
                  disabled={!formik.values.subcategoryId || isPreSubCategoryLoading}
                  className={`form-control-custom w-full flex items-center gap-2 text-left disabled:opacity-50 disabled:cursor-not-allowed ${formik.touched.preSubCategoryId && formik.errors.preSubCategoryId ? "border-red-500" : ""}`}
                  onClick={() => setOpenCatDropdown(v => v === 'presubcategory' ? null : 'presubcategory')}
                  onBlur={() => { setTimeout(() => setOpenCatDropdown(v => v === 'presubcategory' ? null : v), 150); formik.setFieldTouched('preSubCategoryId', true); }}
                >
                  {isPreSubCategoryLoading
                    ? <span className="text-gray-400">{t('advertiser.notifications.loading')}</span>
                    : formik.values.preSubCategoryId
                      ? (() => { const p = preSubCategoryList.find(x => x._id === formik.values.preSubCategoryId); return p ? (<><img src={p.image || p.icon || '/category.png'} alt="" className="w-6 h-6 rounded object-cover flex-shrink-0" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} /><span className="truncate">{p.title}</span></>) : <span className="text-gray-400">{t('advertiser.products.select_pre_sub_category')}</span>; })()
                      : <span className="text-gray-400">{t('advertiser.products.select_pre_sub_category')}</span>
                  }
                  <span className="ml-auto text-gray-400">▾</span>
                </button>
                {openCatDropdown === 'presubcategory' && !isPreSubCategoryLoading && formik.values.subcategoryId && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-56 overflow-y-auto">
                    <div className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-gray-400 text-sm" onClick={() => { formik.setFieldValue('preSubCategoryId', ''); setProductDynamicAttributes([]); setOpenCatDropdown(null); }}>
                      <img src="/category.png" alt="" className="w-6 h-6 rounded object-cover flex-shrink-0 border border-gray-100" />
                      {t('advertiser.products.select_pre_sub_category')}
                    </div>
                    {preSubCategoryList.map(pre => (
                      <div key={pre._id} className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-pink-50 transition-colors ${formik.values.preSubCategoryId === pre._id ? 'bg-pink-50 font-semibold' : ''}`}
                        onClick={() => {
                          formik.setFieldValue('preSubCategoryId', pre._id);
                          setOpenCatDropdown(null);
                          setIsAttributeLoading(true);
                          GetPreSubCategoryDetails(pre._id)
                            .then((res) => {
                              const responseData = res.data || res;
                              const attributes = responseData.data?.attributes || responseData.attributes;
                              if (attributes && Array.isArray(attributes)) {
                                setProductDynamicAttributes(attributes);
                                const currentFormAttrs = Array.isArray(formik.values.attributes) ? [...formik.values.attributes] : [];
                                const updatedAttrs = attributes.map(attr => {
                                  const existing = currentFormAttrs.find(a => a.name === attr.name);
                                  return { name: attr.name, value: existing ? existing.value : (attr.attributeType === "checkbox" ? [] : "") };
                                });
                                formik.setFieldValue('attributes', updatedAttrs);
                              } else { setProductDynamicAttributes([]); }
                            })
                            .catch(() => setProductDynamicAttributes([]))
                            .finally(() => setIsAttributeLoading(false));
                        }}>
                        <img src={pre.image || pre.icon || '/category.png'} alt={pre.title} className="w-7 h-7 rounded object-cover flex-shrink-0 border border-gray-100" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/category.png'; }} />
                        <span className="text-sm text-gray-700">{pre.title}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {formik.touched.preSubCategoryId && formik.errors.preSubCategoryId && (
                <p className="text-red-500 text-sm mt-1">{formik.errors.preSubCategoryId}</p>
              )}
            </div>

            {console.log("Attributes debug:", { preSub: formik.values.preSubCategoryId, dynCount: productDynamicAttributes.length, attrs: productDynamicAttributes })}
            {productDynamicAttributes.length > 0 && (
              <div className="mb-6 p-4 bg-zinc-50 rounded-xl border border-zinc-100">
                <label className="block font-bold text-zinc-800 mb-4">Attributes</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {productDynamicAttributes.map((attr) => {
                    // Find if this attribute already has a value in formik state
                    const attrEntry = formik.values.attributes.find(a => a.name === attr.name);
                    const currentValue = attrEntry ? attrEntry.value : "";

                    const facetValues = attributeFacets[attr.name] || [];
                    const hasPredefinedValues = attr.values && attr.values.length > 0;
                    const hasFacetValues = facetValues.length > 0;
                    const isDropdownType = ["select", "checkbox", "radio"].includes(attr.attributeType);
                    const isUserTextInput = ["text", "number", "user_input"].includes(attr.attributeType) && !hasPredefinedValues;

                    const handleValueChange = (val) => {
                      const newAttrs = [...formik.values.attributes];
                      const index = newAttrs.findIndex(a => a.name === attr.name);
                      if (index > -1) {
                        newAttrs[index].value = val;
                      } else {
                        newAttrs.push({ name: attr.name, value: val });
                      }
                      formik.setFieldValue("attributes", newAttrs);
                    };

                    const colorMap = {};
                    const expandedValues = expandTabValues(attr.values || []);
                    const expandedFacetValues = expandTabValues(facetValues || []);

                    const attrValuesNames = expandedValues.map(val => {
                      if (val && typeof val === 'object') {
                        if (val.name && typeof val.name === 'object' && val.name.name) {
                          const colorName = val.name.name;
                          const colorCode = val.name.colorCode || null;
                          if (colorName) {
                            colorMap[colorName] = colorCode;
                            return colorName;
                          }
                        }
                        if (val.name && typeof val.name === 'string') {
                          const colorName = val.name;
                          const colorCode = val.colorCode || null;
                          colorMap[colorName] = colorCode;
                          return colorName;
                        }
                      }
                      return String(val || '');
                    }).filter(v => v.trim() !== '');

                    const sanitizedFacetValues = expandedFacetValues.map(val => {
                      if (val && typeof val === 'object') {
                        if (val.name && typeof val.name === 'object' && val.name.name) {
                          const colorName = val.name.name;
                          const colorCode = val.name.colorCode || null;
                          if (colorName) {
                            colorMap[colorName] = colorCode;
                            return colorName;
                          }
                        }
                        if (val.name && typeof val.name === 'string') {
                          const colorName = val.name;
                          const colorCode = val.colorCode || null;
                          colorMap[colorName] = colorCode;
                          return colorName;
                        }
                      }
                      return String(val || '');
                    }).filter(v => v.trim() !== '');

                    const isColorAttr = attr.hasColorCode || attr.name.toLowerCase().includes('color') || attr.name.toLowerCase().includes('colour');
                    let selectOptions = [...new Set([...attrValuesNames, ...sanitizedFacetValues])].map(v => ({ label: v, value: v, colorCode: colorMap[v] || null }));
                    const isMulti = attr.isMultiSelect || isColorAttr;

                    // Filter based on selected palate
                    const palateAttr = formik.values.attributes.find(a => a.name.toLowerCase() === 'palate');
                    const selectedPalate = palateAttr ? palateAttr.value : null;
                    if (selectedPalate && (attr.name.toLowerCase().includes('color') || attr.name.toLowerCase().includes('colour'))) {
                      selectOptions = selectOptions.filter(opt => {
                        const optColorCode = opt.colorCode || (String(opt.value || '').toLowerCase() === 'nude' ? '#E3BC9A' : String(opt.value || '').toLowerCase() === 'transparent' ? 'transparent' : String(opt.value || '').toLowerCase().replace(/ /g, ''));
                        const optPalate = getColorPalateName(opt.value, optColorCode);
                        return optPalate.toLowerCase().includes(selectedPalate.toLowerCase()) ||
                          selectedPalate.toLowerCase().includes(optPalate.toLowerCase());
                      });
                    }

                    return (
                      <div key={attr._id} className="form-group mb-0">
                        <label className="text-sm font-medium text-zinc-600 mb-1 d-block">
                          {capitalizeFirstLetter(attr.name)}
                          {isMulti && <span className="text-[10px] ml-2 text-zinc-400">(Multi-select)</span>}
                        </label>

                        {(() => {
                          if (isColorAttr) {
                            const selectedColors = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);

                            return (
                              <div className="mt-2 space-y-3 w-full">
                                <div className="relative">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setActiveTabPopover(
                                        activeTabPopover && activeTabPopover.attrId === attr._id && activeTabPopover.tabName === "complete_palette"
                                          ? null
                                          : { attrId: attr._id, tabName: "complete_palette" }
                                      );
                                    }}
                                    className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-bold transition-all ${selectedColors.length > 0
                                      ? "border-[var(--secondary-500)] bg-[var(--secondary-50)] text-[var(--secondary-700)]"
                                      : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
                                      }`}
                                    style={{
                                      boxShadow: selectedColors.length > 0 ? "0 0 8px rgba(255, 99, 181, 0.2)" : "none",
                                      borderColor: selectedColors.length > 0 ? "#FF63B5" : "#e2e8f0"
                                    }}
                                  >
                                    <span
                                      className="w-4 h-4 rounded-full border border-gray-300 inline-block flex-shrink-0"
                                      style={{
                                        background: selectedColors.length > 0
                                          ? getPalateBackground(selectedColors.map(c => ({ name: c, colorCode: getSwatchColorCode(c) })), "Custom")
                                          : "linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)"
                                      }}
                                    />
                                    <span>Select Colors</span>
                                    {selectedColors.length > 0 && (
                                      <span className="bg-[#FF63B5] text-white text-[9px] px-1.5 py-0.5 rounded-full">
                                        {selectedColors.length}
                                      </span>
                                    )}
                                  </button>
                                </div>

                                {/* Selected Colors Badges */}
                                {selectedColors.length > 0 && (
                                  <div className="flex flex-wrap gap-1.5 mt-2">
                                    {selectedColors.map(v => (
                                      <span key={v} className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-2 py-0.5 rounded-lg text-[10px] font-semibold">
                                        {v}
                                        <button
                                          type="button"
                                          onClick={() => handleValueChange(isMulti ? selectedColors.filter(x => x !== v) : "")}
                                          className="text-gray-400 hover:text-gray-600 font-bold"
                                        >
                                          ✕
                                        </button>
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          }

                          return isMulti ? (
                            <Select
                              isMulti
                              closeMenuOnSelect={false}
                              menuPortalTarget={document.getElementById("create-product")}
                              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              options={selectOptions}
                              placeholder={`Select ${attr.name}`}
                              value={Array.isArray(currentValue)
                                ? currentValue.map(v => ({ label: v, value: v }))
                                : (currentValue ? [{ label: currentValue, value: currentValue }] : [])
                              }
                              onChange={(selectedOptions) => {
                                const values = selectedOptions ? selectedOptions.map(o => o.value) : [];
                                handleValueChange(values);
                              }}
                              formatOptionLabel={({ label, value, colorCode: optionColorCode }) => {
                                 if (attr.hasColorCode || attr.name.toLowerCase().includes('color')) {
                                   const dotStyle = getColorDotStyle(optionColorCode || value, colorPalettes);
                                   return (
                                     <div className="flex items-center gap-2">
                                       <span
                                         className="w-3 h-3 rounded-full inline-block"
                                         style={dotStyle}
                                       ></span>
                                       <span>{label}</span>
                                     </div>
                                   );
                                 }
                                 return label;
                               }}
                            />
                          ) : !isUserTextInput && (hasPredefinedValues || hasFacetValues || isDropdownType) ? (
                            <Select
                              className="react-select-container"
                              classNamePrefix="react-select"
                              menuPortalTarget={document.getElementById("create-product")}
                              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                              options={selectOptions}
                              placeholder={`Select ${attr.name}`}
                              value={selectOptions.find(o => o.value === currentValue) || null}
                              onChange={(selectedOption) => {
                                handleValueChange(selectedOption ? selectedOption.value : "");
                              }}
                              isClearable
                              formatOptionLabel={({ label, value, colorCode: optionColorCode }) => {
                                if (attr.hasColorCode || attr.name.toLowerCase().includes('color')) {
                                  const finalColorCode = optionColorCode || (String(value || '').toLowerCase() === 'nude' ? '#E3BC9A' : String(value || '').toLowerCase() === 'transparent' ? 'transparent' : String(value || '').toLowerCase().replace(/ /g, ''));
                                  return (
                                    <div className="flex items-center gap-2">
                                      <span
                                        className="w-3 h-3 rounded-full border border-gray-300 inline-block"
                                        style={{
                                          backgroundColor: finalColorCode,
                                          backgroundImage: String(value || '').toLowerCase() === 'transparent' ? 'repeating-conic-gradient(#ccc 0% 25%, white 0% 50%) 50% / 100% 100%' : 'none'
                                        }}
                                      ></span>
                                      <span>{label}</span>
                                    </div>
                                  );
                                }
                                return label;
                              }}
                            />
                          ) : (
                            <input
                              type={attr.attributeType === "number" ? "number" : "text"}
                              className="form-control-custom"
                              placeholder={`Enter ${attr.name}`}
                              value={currentValue}
                              min={attr.attributeType === "number" ? "0" : undefined}
                              onKeyDown={(e) => {
                                if (attr.attributeType === "number" && (e.key === "-" || e.key === "Minus")) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                let val = e.target.value;
                                if (attr.attributeType === "number" && val !== "") {
                                  if (val.includes('-') || parseFloat(val) < 0) {
                                    return;
                                  }
                                }
                                handleValueChange(val);
                              }}
                            />
                          );
                        })()}
                      </div>
                    );

                  })}
                </div>
              </div>
            )}




            <div className="flex items-center gap-3 mt-4">
              <button
                type="submit"
                className="btn flex-1 flex justify-center items-center text-center !bg-white !text-[#FF63B5] border !border-[#FF63B5] hover:!bg-[#FF63B5] hover:!text-white transition-colors"
                disabled={formik.isSubmitting}
                onClick={() => formik.setFieldValue("isPublished", false)}
              >
                {formik.isSubmitting
                  ? t('advertiser.products.submitting')
                  : "Save"}
              </button>
              <button
                type="submit"
                className="btn btn-pri flex-1 flex justify-center items-center text-center"
                disabled={formik.isSubmitting}
                onClick={() => formik.setFieldValue("isPublished", true)}
              >
                {formik.isSubmitting
                  ? t('advertiser.products.submitting')
                  : "Save And Publish"}
              </button>
            </div>
          </form>
        </div >
        <form method="dialog">
          <button
            className="bg-white subtitle-2 flex items-center gap-[5px] px-[15px] py-[10px] rounded-full"
            onClick={handleCloseModal}
          >
            <img src="/images/close.svg" alt="close" />
            <span className="subtitle-2 bold">{t("products.close")}</span>
          </button>
        </form>
      </dialog >

      {/* Centered Color Palette Modal Overlay */}
      < dialog id="color-palette-modal" className="modal p-[15px]" style={{ overflow: "visible" }
      }>
        {(() => {
          if (!activeTabPopover || activeTabPopover.tabName !== "complete_palette") return null;

          let attr;
          let selectedColors;
          let handleValueChange;

          if (activeTabPopover.attrId === "default_colors") {
            attr = { name: "Colors" };
            selectedColors = formik.values.colors || [];
            handleValueChange = (val) => {
              formik.setFieldValue("colors", val);
            };
          } else if (activeTabPopover.attrId === "image_color") {
            attr = { name: "Image Color" };
            const img = formik.values.product_images[activeTabPopover.imageIndex];
            selectedColors = img && img.color ? [img.color] : [];
            handleValueChange = (val) => {
              const selectedColor = Array.isArray(val) ? (val[val.length - 1] || "") : val;
              const updated = [...formik.values.product_images];
              updated[activeTabPopover.imageIndex].color = selectedColor;
              formik.setFieldValue("product_images", updated);
            };
          } else {
            attr = productDynamicAttributes.find(a => a._id === activeTabPopover.attrId);
            if (!attr) return null;

            const attrEntry = formik.values.attributes.find(a => a.name === attr.name);
            const currentValue = attrEntry ? attrEntry.value : "";
            selectedColors = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);
            handleValueChange = (val) => {
              const newAttrs = [...formik.values.attributes];
              const index = newAttrs.findIndex(a => a.name === attr.name);
              if (index > -1) {
                newAttrs[index].value = val;
              } else {
                newAttrs.push({ name: attr.name, value: val });
              }
              formik.setFieldValue("attributes", newAttrs);
            };
          }

          const isMulti = activeTabPopover.attrId !== "image_color";

          return (
            <div
              className="modal-box max-w-[645px] !w-full p-4 space-y-3"
              style={{
                overflow: "visible",
                boxShadow: "0 20px 50px rgba(0,0,0,0.3)"
              }}
            >
              {/* Header */}
              <div className="flex items-center justify-between border-b border-gray-100 pb-2">
                <span className="text-xs font-extrabold text-gray-700 uppercase tracking-wider">
                  Select {capitalizeFirstLetter(attr.name)}
                </span>
                <button
                  type="button"
                  onClick={() => setActiveTabPopover(null)}
                  className="text-gray-400 hover:text-gray-600 text-sm font-bold"
                >
                  ✕
                </button>
              </div>

              {/* Content */}
              <div className="pr-1">
                <div className="grid gap-1 bg-gray-50 p-2 rounded-xl border border-gray-200" style={{ gridTemplateColumns: `repeat(${colorPalettes.length || 1}, 1fr)` }}>
                  {colorPalettes.map((col) => (
                    <div
                      key={col.name}
                      style={{
                        background: "#2c2c2c",
                        color: "#ffffff",
                        fontSize: "9px",
                        fontWeight: "bold",
                        textAlign: "center",
                        padding: "4px 1px",
                        borderRadius: "3px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textTransform: "uppercase"
                      }}
                      title={col.name}
                    >
                      {col.name.split(" ")[0]}
                    </div>
                  ))}

                  {Array.from({ length: Math.max(...colorPalettes.map(col => col.colors ? col.colors.length : 0), 1) }).map((_, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      {colorPalettes.map((col) => {
                        const color = col.colors ? col.colors[rowIndex] : null;
                        if (!color) {
                          return <div key={`${col.name}-${rowIndex}`} />;
                        }
                        const isColorSelected = selectedColors.includes(color.name);

                        let swatchBg = color.hex;
                        if (color.name === "Transparent") {
                          swatchBg = 'repeating-linear-gradient(45deg, #e0e0e0, #e0e0e0 4px, #ffffff 4px, #ffffff 8px)';
                        } else if (color.name === "Multicolour") {
                          swatchBg = 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff)';
                        } else if (color.gradient) {
                          swatchBg = color.gradient;
                        }

                        return (
                          <button
                            key={`${col.name}-${rowIndex}`}
                            type="button"
                            title={`${color.name} (${color.hex})`}
                            onClick={() => {
                              let nextValue;
                              if (isMulti) {
                                if (isColorSelected) {
                                  nextValue = selectedColors.filter(v => v !== color.name);
                                } else {
                                  nextValue = [...selectedColors, color.name];
                                }
                              } else {
                                nextValue = isColorSelected ? "" : color.name;
                                setActiveTabPopover(null);
                              }
                              handleValueChange(nextValue);
                            }}
                            style={{
                              width: "100%",
                              height: "22px",
                              background: swatchBg,
                              border: isColorSelected ? "2.5px solid #FF63B5" : "1px solid rgba(0,0,0,0.15)",
                              borderRadius: "3px",
                              cursor: "pointer",
                              transition: "all 0.15s ease",
                              transform: isColorSelected ? "scale(1.05)" : "none"
                            }}
                          />
                        );
                      })}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          );
        })()}
        <form method="dialog">
          <button
            className="fixed inset-0 -z-10 bg-black/40 cursor-default"
            onClick={() => setActiveTabPopover(null)}
          />
        </form>
      </dialog >
    </>
  );
}

export default Products;